import React from 'react';
import { graphql } from 'gatsby';
import { Seo } from '../../common';
import { Layout } from '../../layouts';
import {
  AlternatingRows,
  Article,
  CardGrid,
  CtaSelector,
  FormFull,
  ImageGallery,
  // HeroCenter,
  // HeroCenterForm,
  // HeroGraphic,
  HeroContact,
  HeroForm,
  HeroTestimonial,
  ImageLinkList,
  MapFull,
  UtilitySelector,
} from '../sections';
import { useSanityData } from '../../../hooks';

export const query = graphql`
  query MainPageTemplateQuery($id: String!) {
    mainPage: sanityPage(id: { eq: $id }) {
      ...ContentAlternatingRowsFragment
      ...ContentArticleFragment
      ...ContentCardGridFragment
      ...ContentCtaFragment
      ...ContentImageGalleryFragment
      ...ContentImageLinkListFragment
      ...ContentUtilityFragment
      ...PageGbpFragment
      ...PageHeroFragment
      ...PageNavigationFragment
      ...PageSeoFragment
    }
  }
`;

const MainPageTemplate = function ({ data }) {
  const mainPage = data?.mainPage;
  const sanity = useSanityData();

  const heroSectionComponents = {
    textForm: HeroForm,
    textTestimonial: HeroTestimonial,
    textContact: HeroContact,
    // textOnly: HeroCenter,
    // textForm: HeroCenterForm,
    // textFormChecklist: HeroFormChecklist,
    // textGraphic: HeroGraphic,
  };

  const contentSectionComponents = {
    sectionAlternatingRows: AlternatingRows,
    sectionArticle: Article,
    sectionCta: CtaSelector,
    sectionCardGrid: CardGrid,
    sectionImageGallery: ImageGallery,
    sectionImageLinkList: ImageLinkList,
    sectionUtility: UtilitySelector,
  };

  const HeroSectionComponent =
    heroSectionComponents[mainPage?.heroTemplate] || HeroForm;

  const filteredContentSections = mainPage?.contentSections?.filter(
    (section) => contentSectionComponents[section._type]
  );

  return (
    <Layout page={mainPage} sanity={sanity} pageType={mainPage?.pageType}>
      <Seo page={mainPage} sanity={sanity} />
      {mainPage?.heroTemplate === 'none' ? null : (
        <HeroSectionComponent page={mainPage} sanity={sanity} />
      )}
      {filteredContentSections?.map((section, index) => {
        const uniqueKey = `${section._key}-${index}`;
        const ContentSectionComponent = contentSectionComponents[section._type];
        return ContentSectionComponent ? (
          <ContentSectionComponent
            key={uniqueKey}
            page={mainPage}
            sanity={sanity}
            section={section}
          />
        ) : null;
      })}
      <MapFull page={mainPage} sanity={sanity} />
      <FormFull page={mainPage} sanity={sanity} />
    </Layout>
  );
};

export default MainPageTemplate;
